export default __webpack_public_path__ + "img/dots-vertical.9f1ebb81.svg";